import type { Permission } from "../../../api/adminPermissions";
import { CORE_GROUP, type PermissionGroup } from "./permissionGroups";

interface PermissionGroupListProps {
  group: PermissionGroup;
  selected: string[];
  readOnly: boolean;
  onToggle: (permissions: Permission[], on: boolean) => void;
}

/** One module's permissions, with a head checkbox that selects all of them (mixed when some are). */
export function PermissionGroupList({ group: [moduleId, perms], selected, readOnly, onToggle }: PermissionGroupListProps): React.JSX.Element {
  const count = perms.filter((p) => selected.includes(p.key)).length;
  const all = count === perms.length;
  return (
    <div className="nb-perm-group">
      <label className="nb-perm-head">
        <input
          type="checkbox"
          className="nb-check"
          checked={all}
          ref={(el) => {
            if (el) el.indeterminate = count > 0 && !all;
          }}
          disabled={readOnly}
          onChange={(e) => onToggle(perms, e.target.checked)}
          aria-label={`All permissions of ${moduleId}`}
        />
        <strong>{moduleId === CORE_GROUP ? "Core" : moduleId}</strong>
        <span className="nb-perm-count">{`${count} of ${perms.length}`}</span>
      </label>
      {perms.map((p) => (
        <label key={p.key} className={`nb-perm-row${readOnly ? " is-readonly" : ""}`}>
          <input type="checkbox" className="nb-check" checked={selected.includes(p.key)} disabled={readOnly} onChange={(e) => onToggle([p], e.target.checked)} />
          <div style={{ minWidth: 0 }}>
            <code>{p.key}</code>
            <span>{p.description}</span>
          </div>
        </label>
      ))}
    </div>
  );
}
